
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * TradingMode enum
 */
class TradingMode {
  /**
   * Initialize enum with a given value
   * @param {TradingMode|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof TradingMode) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!TradingMode}
   * @param {!TradingMode} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradingMode)) {
      throw new TypeError('Instance of TradingMode is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!TradingMode}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!TradingMode}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === TradingMode.NORMAL.value) {
      return 'NORMAL'
    }
    if (this.value === TradingMode.CLOSE_ONLY.value) {
      return 'CLOSE_ONLY'
    }
    if (this.value === TradingMode.READ_ONLY.value) {
      return 'READ_ONLY'
    }
    if (this.value === TradingMode.LONG_ONLY.value) {
      return 'LONG_ONLY'
    }
    if (this.value === TradingMode.SHORT_ONLY.value) {
      return 'SHORT_ONLY'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!TradingMode}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!TradingMode}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!TradingMode} Created enum
   */
  static fromObject (other) {
    return new TradingMode(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
TradingMode.NORMAL = new TradingMode(0 + 0)
// noinspection PointlessArithmeticExpressionJS
TradingMode.CLOSE_ONLY = new TradingMode(0 + 1)
// noinspection PointlessArithmeticExpressionJS
TradingMode.READ_ONLY = new TradingMode(0 + 2)
// noinspection PointlessArithmeticExpressionJS
TradingMode.LONG_ONLY = new TradingMode(0 + 3)
// noinspection PointlessArithmeticExpressionJS
TradingMode.SHORT_ONLY = new TradingMode(0 + 4)

export { TradingMode };

/**
 * Fast Binary Encoding TradingMode field model
 */
class FieldModelTradingMode extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelTradingMode}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelTradingMode}
   * @param {TradingMode=} defaults Default value, defaults is new TradingMode()
   * @returns {!TradingMode} Result value
   */
  get (defaults = new TradingMode()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new TradingMode(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelTradingMode}
   * @param {!TradingMode} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelTradingMode };
